import React from 'react';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

const Item = styled(Paper)(({ theme, style }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...style,
}));

interface ItemStackProps {
  items: string[];
  style?: any;
}

export const ItemStack = ({ items, style }: ItemStackProps) => {
  return (
    <Stack direction='row' sx={styles.stack}>
      {items.map((i) => (
        <Item key={i} sx={styles.item} style={style}>
          {i}
        </Item>
      ))}
    </Stack>
  );
};

const styles = {
  stack: { mb: 2, display: 'inline-block' },
  item: {
    display: 'inline-block',
    mb: 1,
    mr: 1,
    fontWeight: 'medium',
  },
};
